const orderConstants = {
  SET_CALLBACK_FUNC: 'ORDER.SET_CALLBACK_FUNC',
  SET_THUOC_INFO: 'ORDER.SET_THUOC_INFO',
  SET_MODE_FORM: 'ORDER.SET_MODE_FORM',
  SET_FLAG_ADD_ITEM: 'ORDER.SET_FLAG_ADD_ITEM',
  SET_WARNING_ITEM: 'ORDER.SET_WARNING_ITEM',
  SET_ERROR: 'ORDER.SET_ERROR',
  SET_IS_LOADING: 'ORDER.SET_IS_LOADING',
  SET_MESSAGE: 'ORDER.SET_MESSAGE',
  SET_TYPEOF_ORDER: 'ORDER.SET_TYPEOF_ORDER',
  SET_ORDER_ID: 'ORDER.SET_ORDER_ID',
  SET_USERS: 'ORDER.SET_USERS',
  SET_ITEM: 'ORDER.SET_ITEM',
  SET_ITEMS: 'ORDER.SET_ITEMS',
  SET_ORDER_INFOR: 'ORDER.SET_ORDER_INFOR',
  SET_USERS_CHECKED: 'ORDER.SET_USERS_CHECKED',
  SET_CUSTOMERS: 'ORDER.SET_CUSTOMERS',
  SET_CUSTOMER_INFO: 'ORDER.SET_CUSTOMER_INFO',
  SET_PRODUCT_PRICE: 'ORDER.SET_PRODUCT_PRICE',
  SET_THUOCS: 'ORDER.SET_THUOCS',
  SET_KHOS: 'ORDER.SET_KHOS',
  SET_ORDER_HISTORY: 'ORDER.SET_ORDER_HISTORY',
  SET_ORDER_CONFIRM_MONEY: 'ORDER.SET_ORDER_CONFIRM_MONEY',
  SET_ORDER_EXPORT: 'ORDER.SET_ORDER_EXPORT',
  UNLOCK_ORDER: 'ORDER.UNLOCK_ORDER',
  LOAD_USERS: 'ORDER.LOAD_USERS',
  LOAD_CUSTOMERS: 'ORDER.LOAD_CUSTOMERS',
  LOAD_CUSTOMER_INFO: 'ORDER.LOAD_CUSTOMER_INFO',
  LOAD_THUOCS: 'ORDER.LOAD_THUOCS',
  LOAD_KHOS: 'ORDER.LOAD_KHOS',
  LOAD_THUOC_INFO: 'ORDER.LOAD_THUOC_INFO',
  LOAD_ORDER_HISTORY: 'ORDER.LOAD_ORDER_HISTORY',
  LOAD_ORDER_EXPORT: 'ORDER.LOAD_ORDER_EXPORT',
  LOAD_ORDER_EXCEL: 'ORDER.LOAD_ORDER_EXCEL',
  LOAD_PRODUCT_PRICE: 'ORDER.LOAD_PRODUCT_PRICE',
  CALC_ORDER: 'ORDER.CALC_ORDER',
  CAN_PUSH_ORDER: 'ORDER.CAN_PUSH_ORDER',
  RESET_FORM: 'ORDER.RESET_FORM',
  SAVE_ORDER: 'ORDER.SAVE_ORDER',
  DELETE_ORDER: 'ORDER.DELETE_ORDER',
  CANCEL_ORDER: 'ORDER.CANCEL_ORDER',
  APPROVE_ORDER: 'ORDER.APPROVE_ORDER',
  PROCESS_ORDER: 'ORDER.PROCESS_ORDER',
  RETURN_ORDER: 'ORDER.RETURN_ORDER',
  CONVERT_ORDER: 'ORDER.CONVERT_ORDER',
  REVERT_ORDER: 'ORDER.REVERT_ORDER',
  SET_ORDER_TOTAL: 'ORDER.SET_ORDER_TOTAL',
  LOAD_ORDER_DETAILS: 'ORDER.LOAD_ORDER_DETAILS',
  LOAD_USERS_API: '/api/v1//users/get_list_by_quanly',
  LOAD_THUOCS_API: '/api/v1/export/list_thuoc_for_export_by',
  LOAD_THUOC_INFO_API: '/api/v1/export/update_thuoc_for_order',
  LOAD_CUSTOMERS_API: '/api/v1/export/get_customers_for_order',
  LOAD_CUSTOMER_INFO_API: '/api/v1/export/customer_details',
  LOAD_KHOS_API: '/api/v1/kho/get_kho_of_user',
  SAVE_ORDER_API: '/api/v1/export/save_order',
  UNLOCK_ORDER_API: '/api/v1/export/unlock_order',
  LOAD_ORDER_DETAILS_API: '/api/v1/export/order_details',
  DELETE_ORDER_API: '/api/v1/export/delete_order',
  CANCEL_ORDER_API: '/api/v1/export/cancel_order',
  APPROVE_ORDER_API: '/api/v1/export/approve_order',
  PROCESS_ORDER_API: '/api/v1/export/process_order',
  RETURN_ORDER_API: '/api/v1/export/return_order',
  CONVERT_ORDER_API: '/api/v2/export/convert_order',
  REVERT_ORDER_API: '/api/v1/export/revert_order',
  LOAD_ORDER_HISTORY_API: '/api/v1/giaohang/giaohang_lich_su_by_order',
  SET_ORDER_CONFIRM_MONEY_API: '/api/v1/giaohang/giaohang_confirm_received_money',
  LOAD_ORDER_EXPORT_API: '/api/v1/export/export_order',
  LOAD_ORDER_EXCEL_API: '/api/v1/export/order_export_by_store',
  CALC_ORDER_API: '/api/v1/export/calc_order',
  CAN_PUSH_ORDER_API: '/api/v1/export/can_push_order',
  LOAD_PRODUCT_PRICE_API: '/api/v1/management/get_product_price',
  TYPEOF_ORDER: {
    FOR_DEFAULT: 1,
    FOR_STORE: 2,
    FOR_RETURN: 3,
  },
  MODE: {
    IN_CREATE: 'IN_CREATE',
    IN_EDIT: 'IN_EDIT',
    IN_VIEW: 'IN_VIEW'
  }
}

export const FormFiels = {
  KhoNhapId: "kho_nhao_id",
  KhachHangId: 'khach_hang_id',
  MaKhachHang: 'ma_khach_hang',
  TenKhachHang: 'ten_khach_hang',
  DiaChi: 'dia_chi',
  DienThoai: 'dien_thoai',
  MaSoThue: 'ma_so_thue',
  HdThamGia: 'hd_tham_gia',
  DiemTichLuy: 'diem_tich_luy',
  NhanVienId: 'nhan_vien_id',
  TenNhanVien: "ten_nhan_vien",
  KhoXuatId: 'kho_xuat_id',
  TenKhoXuat: 'ten_kho',
  BoChietKhau: 'bo_chiet_khau',
  XuatHoaDon: 'xuat_hoa_don',
  GhiChu: 'ghi_chu',
  NgayLap: 'ngay_lap',
  NgayGiao: 'ngay_giao',
  Id: 'id',
  OrderId: 'order_id',
  Diem: 'diem',
  ChietKhau: 'chiet_khau',
  ThanhTien: 'thanh_tien',
  TrangThai: 'trang_thai',
  CkPercent: 'CkPercent'
}

export default orderConstants;


// WEBPACK FOOTER //
// ./src/views/Order/constants.js